import { memo } from 'react';
import { IProduct } from '../../interfaces/IProduct';
import { Stack } from '@mui/material';
import { CurrencyValue } from '@dfl/mui-react-common';
import { useCurrency } from 'contexts/CurrencyProvider';

type Props = {
  record: Pick<IProduct, 'priceDetails' | 'price'>;
  value: number;
};

const FinalPriceCell = ({ record, value: finalPrice }: Props) => {
  const { primary } = useCurrency();

  if (record?.priceDetails?.values?.offer) {
    return (
      <Stack>
        <CurrencyValue
          sx={{ fontSize: 12, textDecoration: 'line-through', fontWeight: 300 }}
          value={record?.price || 0}
          currency={primary}
        />
        <CurrencyValue value={finalPrice} currency={primary} />
      </Stack>
    );
  }
  return <CurrencyValue value={finalPrice} currency={primary} />;
};

export default memo(FinalPriceCell);
